<template lang="pug">
  div.fs-13.color-primary.info-msg(style="height: 13px; width: 100%; line-height: 1.42857143; font-family: var(--front-font);")
    | {{ info }}

</template>

<script>
export default {
  name: 'InfoMsg',
  props: {
    info: {type: String, 'default': ''}
  }
}
</script>

<style scoped>

</style>
